/**
 * @since 1.0.0
 * @visibleName FILE_TYPES
 * @component
 */
export default {
  WORD: '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  EXCEL: '.xls,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
  HTML: '.html,.htm,text/html',
  AUDIO: 'audio/*',
  PDF: '.pdf',
  IMAGE: 'image/*',
  TEXT: 'text/plain',
  CSV: '.csv',
  VIDEO: 'video/*',
} as const;
